<template>
  <div class="d-inline-block">
    <icon-button
      variant="primary"
      icon="arrow-up-right-circle"
      @click="openModal"
    ></icon-button>
    <b-modal
      v-model="dialog"
      title="Request Supra Urgent Review"
      centered
      size="lg"
      @ok="submitReview"
      ok-title="Send Review Request"
      :ok-disabled="selectedCount === 0 || submitting"
    >
      <div v-if="loading" class="text-center py-4">
        <b-spinner variant="primary" small></b-spinner>
      </div>
      <div v-else-if="approvers.length === 0" class="text-center py-3">
        <p class="text-muted mb-0">No Supra Urgent approvers found for this organ.</p>
      </div>
      <template v-else>
        <p class="mb-2">
          <strong>Organ:</strong> {{ organName }} |
          <strong>Supra Urgent ID:</strong> {{ item.alf_id }}
        </p>
        <b-table
          :items="approvers"
          :fields="fields"
          small
          striped
          responsive
          hover
        >
          <template #cell(sno)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(name)="data">
            {{ data.item.first_name }} {{ data.item.last_name }}
          </template>
          <template #cell(skip)="data">
            <b-form-checkbox
              v-model="data.item.skip"
              :disabled="submitting"
            >
              Skip
            </b-form-checkbox>
          </template>
        </b-table>
        <small class="text-muted">
          {{ selectedCount }} approver{{ selectedCount > 1 ? "s" : "" }}
          selected
          <span v-if="skippedCount > 0">
            ({{ skippedCount }} skipped)
          </span>
        </small>
      </template>
    </b-modal>
  </div>
</template>

<script>
import alfService from "../../assets/services/alf.service";
import IconButton from "../buttons/IconButton.vue";

export default {
  name: "ALFReviewRequest",
  components: { IconButton },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      submitting: false,
      approvers: [],
      fields: [
        { key: "sno", label: "S.No" },
        { key: "name", label: "Name" },
        { key: "organ_name", label: "Organ" },
        { key: "hospital_name", label: "Hospital" },
        { key: "phone_number_1", label: "Phone" },
        { key: "skip", label: "Skip" },
      ],
    };
  },
  computed: {
    organName() {
      return this.item.organ_type_name || "Liver";
    },
    organType() {
      return this.item.organ_type;
    },
    selectedApprovers() {
      return this.approvers.filter((a) => !a.skip);
    },
    selectedCount() {
      return this.selectedApprovers.length;
    },
    skippedCount() {
      return this.approvers.filter((a) => a.skip).length;
    },
  },
  methods: {
    async openModal() {
      this.dialog = true;
      await this.fetchApprovers();
    },
    async fetchApprovers() {
      this.loading = true;
      try {
        const { data } = await alfService.getALFApproversForOrgan();
        if (data.status && data.list) {
          let list = data.list.map((a) => ({ ...a, skip: false }));
          // Filter by organ: show approvers who have the matching organ
          if (this.organType) {
            list = list.filter((a) => {
              if (!a.organ_name) return false;
              let organs = a.organ_name.split(", ");
              return organs.some(
                (o) => o.toLowerCase() === this.organName.toLowerCase()
              );
            });
          }
          this.approvers = list;
        }
      } catch (error) {
        this.$alert.show("Error loading approvers");
      } finally {
        this.loading = false;
      }
    },
    async submitReview(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.submitting = true;
      try {
        let registration_ids = this.selectedApprovers
          .map((a) => a.registration_id)
          .join(",");
        let doc = {
          alf_id: this.item.alf_id,
          created_by: this.created_by,
          dml_indicator: "I",
          registration_ids,
        };
        let { data } = await alfService.requestALFReview(doc);
        let { status, msg } = data;
        if (!status) {
          this.$alert.show(msg);
          return;
        }
        this.dialog = false;
        this.$alert.show("Supra Urgent review requested successfully", "success");
        this.$emit("fetch");
      } catch (error) {
        this.$alert.show(error.message);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
